import Upload from "./upload";
import dealValidate from "@/utils/validate";
import Types from "./types";
const defaultProps = {
  input: {
    placeholder: "请输入",
    clearable: true,
  },
  select: {
    placeholder: "请选择",
    clearable: true,
  },
  datePicker: {
    type: "datetimerange",
    placeholder: "请选择日期",
  },
};

export default {
  methods: {
    renderFormItem(h, data) {
      if (data.hidden === true) {
        return null;
      }
      if (data.condition && !data.condition(this.formData)) {
        return null;
      }
      if (data.type === "row") {
        return (
          <el-row>
            {data.children.map((item) => {
              return (
                <el-col attrs={{ ...item.col }}>
                  {this.renderFormItem(h, item)}
                </el-col>
              );
            })}
          </el-row>
        );
      }
      const { title, className, info, labelWidth, visible } = data;
      let _title = title;
      let _info = info;
      let _visible = visible;
      if (typeof title === "function") {
        _title = title(this.formData);
      }
      if (typeof info === "function") {
        _info = info(this.formData);
      }
      if (typeof _visible === "function") {
        _visible = _visible(this.formData);
      }
      return (
        <el-form-item
          hidden={_visible === false}
          key={data.field}
          prop={data.field}
          labelWidth={labelWidth}
          class={className}
          rules={dealValidate(data.validate, data.type, _title, data.required)}
        >
          <span slot="label">
            <span>{_title?.replace(/(：|:)$/, "")}</span>
            {data.tip && (
              <el-tooltip
                effect="light"
                popper-class="cs-form-tooltip"
                content={data.tip}
                placement="right"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            )}
            {_title && this.formAttrs.showColon && <span>：</span>}
          </span>
          {this.renderFormItemContent(h, data)}
          {_info && <div class="el-form-item__info">{_info}</div>}
        </el-form-item>
      );
    },
    renderFormItemContent(h, data) {
      const { type } = data;

      if (type === "input") {
        const prepend = data.prepend;
        const append = data.append;
        return (
          <el-input
            vModel={this.formData[data.field]}
            attrs={{ ...defaultProps.input, ...data.props }}
            on={data.on}
          >
            {prepend && <template slot="prepend">{prepend}</template>}
            {append && <template slot="append">{append}</template>}
          </el-input>
        );
      } else if (type === "select") {
        const { options, on } = data;
        return (
          <Types.select
            vModel={this.formData[data.field]}
            options={options}
            listeners={on}
            attrs={{ ...data.props }}
          />
        );
      } else if (type === "checkbox") {
        const { options } = data;
        return (
          <el-checkbox-group
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          >
            {options.map(({ label, value, disabled }) => {
              return (
                <el-checkbox label={value} key={value} disabled={disabled}>
                  {label}
                </el-checkbox>
              );
            })}
          </el-checkbox-group>
        );
      } else if (type === "radio") {
        const { options } = data;
        return (
          <el-radio-group
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          >
            {options.map(({ label, value, type, disabled }) => {
              if (type === "button") {
                return (
                  <el-radio-button
                    label={value}
                    key={value}
                    disabled={disabled}
                  >
                    {label}
                  </el-radio-button>
                );
              } else {
                return (
                  <el-radio label={value} key={value} disabled={disabled}>
                    {label}
                  </el-radio>
                );
              }
            })}
          </el-radio-group>
        );
      } else if (type === "inputNumber") {
        return (
          <el-input-number
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-input-number>
        );
      } else if (type === "autoComplete") {
        return (
          <el-autocomplete
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-autocomplete>
        );
      } else if (type === "switch") {
        return (
          <el-switch
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-switch>
        );
      } else if (type === "cascader") {
        return (
          <el-cascader
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-cascader>
        );
      } else if (type === "datePicker") {
        return (
          <el-date-picker
            vModel={this.formData[data.field]}
            attrs={{ ...defaultProps.datePicker, ...data.props }}
            on={data.on}
          ></el-date-picker>
        );
      } else if (type === "timePicker") {
        return (
          <el-time-select
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-time-select>
        );
      } else if (type === "timePickerPlus") {
        return (
          <el-time-picker
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-time-picker>
        );
      } else if (type === "slider") {
        return (
          <el-slider
            vModel={this.formData[data.field]}
            attrs={{ ...data.props }}
            on={data.on}
          ></el-slider>
        );
      } else if (type === "upload") {
        const { tip, action, accept, ...props } = data.props;
        let _accept = accept;
        if (typeof _accept === "function") {
          _accept = _accept(this.formData);
        }
        let _tip = tip;
        if (typeof _tip === "function") {
          _tip = _tip(this.formData);
        }
        let _action = action;
        if (!_action) {
          _action = "void";
        }
        return (
          <Upload
            vModel={this.formData[data.field]}
            attrs={{ ...props, tip: _tip, accept: _accept, action: _action }}
          ></Upload>
        );
      } else if (type === "custom") {
        if (data.customRender) {
          return data.customRender(h);
        } else if (data.scopedSlots) {
          const onInput = (val) => {
            this.formData[data.field] = val;
          };
          return this.$scopedSlots[data.scopedSlots]({
            value: this.formData[data.field],
            attrs: data.props,
            listeners: {
              input: onInput,
              ...data.on,
            },
          });
        } else if (data.component) {
          const CustomComponent = data.component;
          return (
            <CustomComponent
              vModel={this.formData[data.field]}
              attrs={{ ...data.props }}
              on={data.on}
            ></CustomComponent>
          );
        }
      } else if (type === "text") {
        let value = this.formData[data.field];
        if (data.options && data.options.length > 0) {
          return (
            <span>
              {data.options.find((item) => item.value === value)?.label}
            </span>
          );
        } else {
          return <span>{value}</span>;
        }
      }
    },
  },
};
